import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bulk-change-eta__container" }
const _hoisted_2 = { class: "bulk-change-eta__text" }
const _hoisted_3 = { class: "eta__container" }
const _hoisted_4 = { class: "bulk-change-eta__text" }
const _hoisted_5 = { class: "eta__body" }
const _hoisted_6 = { class: "bulk-change-eta__text" }
const _hoisted_7 = { class: "orders__container" }
const _hoisted_8 = { class: "bulk-change-eta__text" }

import { i18n } from '@/i18n';
import OrderGroupInfoSection from '../../../corePagesModule/components/OrderGroup/OrderGroupInfoSection.vue';
import { IOrderGroup } from '@/coreDomainsModule/entities/IOrderGroup';
import EzTable from '@/corePagesModule/components/ezTable/EzTable.vue';
import EzTableRow from '@/corePagesModule/components/ezTable/EzTableRow.vue';
import EzHeader from '@/corePagesModule/components/ezTable/EzHeader.vue';
import EzCell from '@/corePagesModule/components/ezTable/EzCell.vue';
import SvgLoader from '@/utils/SvgLoader.vue';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { Order } from '@/coreDomainsModule/entities/order';
import { onMounted, ref } from 'vue';
import { LoadingStatus, loadingStatusHelpers } from '@/corePagesModule/components/ezTable/types';
import { OrderGroupService } from '@/orderTableModule/domains/service/orderGroupService';
import { diContainer } from '@/coreContainer/container';
import { initPagingOptions } from '@/coreDomainsModule/paging';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderGroupBulkChangeETAModalContent',
  props: {
    changedETA: {},
    targetOrderGroup: {}
  },
  setup(__props: any) {

const t = i18n.t;

const items = ref<Order[]>([]);
const loadingStatus = ref<LoadingStatus>({ type: 'loading' });

const props = __props;

const gridTemplateColumns: string[] = ['124px', '124px', '124px', '124px', '124px', '124px', '80px', '124px'];

/**
 * fetchとinitialization
 */
const fetchAndInitItem = async () => {
  const { loadingStatus: fetchLoadingStatus, items: fetchItems } = await _fetchOrderLinkedTargetOrderGroup(
    props.targetOrderGroup.orderGroupId
  );
  loadingStatus.value = fetchLoadingStatus;
  if (!loadingStatusHelpers.isError(fetchLoadingStatus) && fetchItems) {
    items.value = fetchItems;
  }
};

/**
 * 対象の発注グループに紐づく発注を取得する
 * @param orderGroupId - 対象の発注グループID
 */
const _fetchOrderLinkedTargetOrderGroup = async (orderGroupId: string): Promise<{ loadingStatus: LoadingStatus; items?: Order[] }> => {
  const useFilterItems = [OrderGroupService.getFilterContentItem(orderGroupId)];
  const result = await diContainer.getUnorderedArrivalUseCase.Execute(false, initPagingOptions(100), 'orderId', true, useFilterItems, {
    ApprovedAwaitingDeliveryDate: true,
    QuantityConfirmed: true,
    DeliveryDateConfirmed: true,
    PartialDelivery: true,
    Confirmed: true,
    Delivered: true,
    DeliveryDelayed: true,
    ApprovalRequested: false,
  });
  let loadingStatus: LoadingStatus = { type: 'loading' };
  switch (result.status.type) {
    case 'success':
      if ((result.status.data.pagingOptions?.returnCount ?? 0) === 0) {
        loadingStatus = { type: 'zero-match' };
      } else {
        loadingStatus = { type: 'success' };
      }
      return {
        loadingStatus,
        items: result.status.data.result,
      };
    case 'error':
      loadingStatus = {
        type: 'error',
        errorMessage: '取得に失敗しました',
      };
      return {
        loadingStatus,
      };
  }
};

onMounted(async () => {
  await fetchAndInitItem();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(t)('発注グループ設定')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('納期')), 1),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(SvgLoader, { name: "calendar_today_gray2x" }),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(DateService).convertIYearMonthDayToYYYYMMDDWithSlash(_unref(DateService).convertUnixTimeToIDate(props.changedETA / 1000))), 1)
      ])
    ]),
    _createVNode(OrderGroupInfoSection, {
      "order-group-name": props.targetOrderGroup.orderGroupName,
      "number-of-order": props.targetOrderGroup.linkedOrderCount,
      "upper-limit-quantity": props.targetOrderGroup.upperLimitQuantity,
      "total-amount": props.targetOrderGroup.totalLinkedOrderAmount,
      "has-background": false
    }, null, 8, ["order-group-name", "number-of-order", "upper-limit-quantity", "total-amount"]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('発注グループ詳細')), 1),
      _createVNode(EzTable, {
        "grid-template-columns": gridTemplateColumns,
        "sticky-header": "",
        "max-height": "300px",
        "loading-status": loadingStatus.value,
        onRetry: fetchAndInitItem
      }, {
        header: _withCtx(() => [
          _createVNode(EzHeader, { class: "orders__header" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('置場コード')), 1)
            ], undefined, true),
            _: 1
          }),
          _createVNode(EzHeader, { class: "orders__header" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('置場名')), 1)
            ], undefined, true),
            _: 1
          }),
          _createVNode(EzHeader, { class: "orders__header" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('仕入先コード')), 1)
            ], undefined, true),
            _: 1
          }),
          _createVNode(EzHeader, { class: "orders__header" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('仕入先名')), 1)
            ], undefined, true),
            _: 1
          }),
          _createVNode(EzHeader, { class: "orders__header" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('商品コード')), 1)
            ], undefined, true),
            _: 1
          }),
          _createVNode(EzHeader, { class: "orders__header" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('商品名')), 1)
            ], undefined, true),
            _: 1
          }),
          _createVNode(EzHeader, { class: "orders__header" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('容量')), 1)
            ], undefined, true),
            _: 1
          }),
          _createVNode(EzHeader, { class: "orders__header" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('発注数量')), 1)
            ], undefined, true),
            _: 1
          })
        ]),
        body: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (order, index) => {
            return (_openBlock(), _createBlock(EzTableRow, {
              id: `orders-row-${index}`,
              key: order.orderId,
              "grid-template-columns": gridTemplateColumns,
              class: "orders__row"
            }, {
              default: _withCtx(() => [
                _createVNode(EzCell, { class: "orders__data" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(order.warehouseNumber), 1)
                  ], undefined, true),
                  _: 2
                }, 1024),
                _createVNode(EzCell, { class: "orders__data" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(order.warehouse), 1)
                  ], undefined, true),
                  _: 2
                }, 1024),
                _createVNode(EzCell, { class: "orders__data" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(order.supplierNumber), 1)
                  ], undefined, true),
                  _: 2
                }, 1024),
                _createVNode(EzCell, { class: "orders__data" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(order.supplierName), 1)
                  ], undefined, true),
                  _: 2
                }, 1024),
                _createVNode(EzCell, { class: "orders__data" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(order.businessNumber), 1)
                  ], undefined, true),
                  _: 2
                }, 1024),
                _createVNode(EzCell, { class: "orders__data" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(order.businessName), 1)
                  ], undefined, true),
                  _: 2
                }, 1024),
                _createVNode(EzCell, { class: "orders__data" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(order.package), 1)
                  ], undefined, true),
                  _: 2
                }, 1024),
                _createVNode(EzCell, { class: "orders__data" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(order.orderAmount.addComma()), 1)
                  ], undefined, true),
                  _: 2
                }, 1024)
              ], undefined, true),
              _: 2
            }, 1032, ["id"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["loading-status"])
    ])
  ]))
}
}

})